import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { fontSizes, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

const pointTitleWidthPx = '76px';

export const progressBarContainer = style([
  {
    width: '100%',
    height: 60,
    margin: `${space.s16}px 0`,
  },
]);

export const progressBar = style([
  {
    width: '100%',
    position: 'relative',
    height: 20,
  },
]);

export const progressLine = style([
  {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    height: 1,

    selectors: {
      '&[data-state="filled"]': {
        background: themeVars.selectors.background.filled,
        left: `calc(${pointTitleWidthPx}/2)`,
        right: '50%',
      },
      '&[data-state="empty"]': {
        background: themeVars.selectors.border.idle,
        left: '50%',
        right: `calc(${pointTitleWidthPx}/2)`,
      },
    },
  },
]);

export const progressPoint = style([
  {
    fontSize: fontSizes.labelSm,
    height: 20,
    width: 20,
    borderRadius: 9999,
    position: 'absolute',
    border: `1px solid ${themeVars.selectors.border.on}`,
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    selectors: {
      '&[data-state="filled"]': {
        background: themeVars.selectors.border.on,
        color: themeVars.selectors.foreground.filled,
        left: `calc(${pointTitleWidthPx}/2)`,
        transform: 'translateX(-50%)',
      },
      '&[data-state="current"]': {
        background: themeVars.container.primary.background.idle,
        color: themeVars.selectors.border.on,
        right: '50%',
        transform: 'translateX(50%)',
      },
      '&[data-state="empty"]': {
        background: themeVars.container.primary.background.idle,
        border: `1px solid ${themeVars.selectors.border.idle}`,
        right: `calc(${pointTitleWidthPx}/2)`,
        transform: 'translateX(50%)',
      },
    },
  },
]);

export const pointTitle = style([
  typography.labelSm,
  {
    width: pointTitleWidthPx,
    color: themeVars.container.foreground.secondary,
  },
]);

export const pointTitlesContainer = style([
  {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'center',
    marginTop: space.s2,
  },
]);
